<script setup>
import { EnvelopeIcon } from "@heroicons/vue/24/outline"
</script>

<template>
  <main
    class="pt-32 pb-12 md:pt-40 md:pb-20 mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-6 lg:px-8"
  >
    <div class="flex flex-shrink-0 justify-center">
      <div
        class="inline-flex flex h-24 w-24 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:h-24 sm:w-24"
      >
        <EnvelopeIcon class="h-12 w-12 text-green-600" aria-hidden="true" />
      </div>
    </div>

    <div class="py-8">
      <div class="text-center">
        <h1
          class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl"
        >
          {{ $t("sign-up.success.title") }}
        </h1>
        <p></p>
        <div class="mt-6">
          <p
            class="text-base font-medium text-indigo-600 hover:text-indigo-500"
          >
            {{ $t("sign-up.success.description") }}
          </p>
        </div>
      </div>
    </div>
  </main>
</template>
